import React from "react";
import { Hero, Analytics, Newsletter, Cards } from './Landing Page'

const LandingPage=()=> {
    return (  
      <>
      <Hero/>
      <Cards />
      <Analytics/>
      <Newsletter/></>
    )
}

export default LandingPage